'use strict';

const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');

module.exports=AngularHelpers.registerModule({
name:'fdc.features.dashboard',
dependencies:['ui.router'],
configs:[
require('./dashboardConfig')],

components:[
require('./dashboardController'),
require('./components/dashboardListDirective'),
require('./components/dashboardHeatmapDirective')]});
//# sourceMappingURL=index.js.map
